<div class="progress-bar-container">
  <div class="progress-text caption">
    <span>Sampling progress</span>{{ position }} / {{ totalTaskNumber }}
  </div>

  <h3-progress-bar [categories]="categories$ | async"></h3-progress-bar>
</div>
<button
  mat-icon-button
  (click)="togglePanel()"
  cdkOverlayOrigin
  #reviewStatusPanelTrigger="cdkOverlayOrigin"
>
  <mat-icon>expand_more</mat-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOffsetX]="-200"
  [cdkConnectedOverlayOrigin]="reviewStatusPanelTrigger"
  [cdkConnectedOverlayOpen]="showPanel$ | async"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="closePanel()"
  cdkConnectedOverlayBackdropClass="panel-backdrop-class"
>
  <div class="panel-container">
    <div class="panel-header subtitle-02"><span>Task status</span></div>
    <ul>
      @for (task of taskStatusList$ | async; track task; let i = $index) {
        <li (click)="goToTask(i + 1)" [class.current-task]="i + 1 === position">
          <div class="list-item-container body-01">
            <span class="status-text">{{ i + 1 }} - {{ task.task_id }}</span>
            <mat-icon
              [class.material-symbols-outlined]="!task.reviewed"
              [matBadge]="getFeedbackCount(task)"
              matBadgeOverlap="true"
              matBadgeSize="small"
              matBadgeColor="warn"
            >
              check_circle
            </mat-icon>
          </div>
        </li>
      }
    </ul>
  </div>
</ng-template>
